<template>
  <button
    class="button-element"
    :type="buttonType"
    @click="action"
  >{{ text }}</button>
</template>

<script>
export default {
  name: 'ButtonElement',
  props: {
    text: String,
    type: String,
    action: Function
  },
  computed: {
    buttonType() {
      return this.type || "button"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.button-element {
  appearance: none;
  cursor: pointer;
  display: inline-block;
  font-family:"basic-sans";
  line-height: 1.28;
  margin: 0 auto;
  outline: none;
  position: relative;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
  width: auto;

  &.disabled {
    cursor: auto;
  }

  &.primary {
    background-color: $primary_purple_3;
    border: 1px solid transparent;
    color: $white;
    font-family:"basic-sans";
    font-size: 14px;
    font-weight: bold;
    max-width: 100%;
    min-width: 228px;
    padding: 21px 35px;

    &:hover {
      background-color: $hover_purple;
    }

    &:focus-visible {
      background-color: $hover_purple;
      border-color: $secondary_green;
    }

    &.disabled {
      opacity: 0.5;
      
      &:hover, &:focus-visible {
        background-color: $primary_purple_3;
        color: $white;
      }  
    }
  }

  &.secondary {
    background-color: $secondary_dark_blue;
    border: 2px solid $white;
    color: $white;
    font-size: 14px;
    font-weight: bold;
    max-width: 100%;
    min-width: 127px;
    padding: 9px 24px;

    &:hover {
      background-color: $white;
      color: $secondary_dark_blue;
    }

    &:focus-visible {
      background-color: $white;
      border-color: $secondary_green;
      color: $secondary_dark_blue;
    }

    &.disabled {
      border-color: rgba($white, 0.5);
      color: rgba($white, 0.5);

      &:hover, &:focus-visible {
        background-color: rgba($secondary_dark_blue, 0.5);
        color: rgba($white, 0.5);
      }
    }
  }

  &.tertiary {
    background: $primary_purple_3;
    color: $white;

    &:hover {
      background-color: $hover_purple;
      color: $white;
    }

    &:focus-visible {
      background-color: $hover_purple;
      border-color: $secondary_green;
      color: $white;
    }

    &.disabled {
      &:hover, &:focus-visible {
        background-color: $primary_purple_3;
        color: $white;
      }
    }
  }
}
</style>
